import React from "react";
import { Box, Button, Card, Typography } from "@mui/material";
import PolicyCardStyles from "./PolicyCardStyles";
import { useNavigate } from "react-router-dom";
import { getCookie } from "../../utils/Utility";

const PolicyCard = ({ item }: any) => {
  const navigate = useNavigate();
  const carrier = getCookie("carrier");
  const system = getCookie("system");
  const redirectToDetails = () => {
    navigate(
      `/agent/policyDetails/${item.containerId}/${carrier}/${system}/${item.productName}/2001`
    );
  };
  return (
    <Card sx={PolicyCardStyles.policyCard}>
      <Box sx={PolicyCardStyles.containerTwo}>
        <Box>
          <Typography sx={PolicyCardStyles.policyCardItemHeading}>
            {item?.customerName}
          </Typography>
          <Typography sx={PolicyCardStyles.policyCartItemContent}>
            Customer Name
          </Typography>
        </Box>
        <Box>
          <Typography sx={PolicyCardStyles.policyCardItemHeading}>
            {item?.insuredName}
          </Typography>
          <Typography sx={PolicyCardStyles.policyCartItemContent}>
            Insured Name
          </Typography>
        </Box>
        <Box>
          <Typography sx={PolicyCardStyles.policyCardItemHeading}>
            {item?.productName}
          </Typography>
          <Typography sx={PolicyCardStyles.policyCartItemContent}>
            Product Name
          </Typography>
        </Box>
        <Box>
          <Typography sx={PolicyCardStyles.policyCardItemHeading}>
            {item?.status}
          </Typography>
          <Typography sx={PolicyCardStyles.policyCartItemContent}>
            Status
          </Typography>
        </Box>
        <Box>
          <Typography sx={PolicyCardStyles.policyCardItemHeading}>
            {item?.inceptionDate}
          </Typography>
          <Typography sx={PolicyCardStyles.policyCartItemContent}>
            Inception Date
          </Typography>
        </Box>
        <Box>
          <Typography sx={PolicyCardStyles.policyCardItemHeading}>
            {item?.expirationDate}
          </Typography>
          <Typography sx={PolicyCardStyles.policyCartItemContent}>
            Expiration Date
          </Typography>
        </Box>
        <Box sx={{ gridColumn: { xs: "1/-1", md: "span 2" } }}>
          <Typography sx={PolicyCardStyles.policyCardItemHeading}>
            {item?.number}
          </Typography>
          <Typography sx={PolicyCardStyles.policyCartItemContent}>
            Policy Number
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="contained"
          sx={PolicyCardStyles.policyCardAction}
          onClick={redirectToDetails}
        >
          View More
        </Button>
      </Box>
    </Card>
  );
};

export default PolicyCard;
